module.exports = "/_next/static/images/ef9647291a0089e805fc732dc599f0ef-pregnant-woman@tablet@3x.jpg";